import React, { useState, useRef, useEffect } from 'react';
import { WidgetInstance } from 'friendly-challenge';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) ||
        arr['@@iterator'];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(n);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function FC_PUZZLE_EP(endpoint) {
  switch (endpoint) {
    case 'GLOBAL1':
      return 'https://api.friendlycaptcha.com/api/v1/puzzle';
    case 'EU1':
      return 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle';
  }
}
function hasUppercase(str) {
  for (var i = 0; i < str.length; i++) {
    if (str[i] !== str[i].toLowerCase()) {
      return true;
    }
  }
  return false;
}
function transformToKebabCase(str) {
  return str.replace(/[A-Z]/g, function (match) {
    return '-'.concat(match.toLowerCase());
  });
}
function cssToString(css) {
  if (css === undefined) {
    return '';
  }
  var cssString = '';
  Object.entries(css).forEach(function (param) {
    var _param = _slicedToArray(param, 2),
      key = _param[0],
      value = _param[1];
    if (hasUppercase(key)) {
      key = transformToKebabCase(key);
    }
    cssString = cssString + ' '.concat(key, ': ').concat(value, ';');
  });
  return cssString;
}
var FriendlyCaptcha = function (props) {
  var ref, ref1, ref2;
  // container is set in return function, where the <div> gets the container as ref attribute.
  var container = useRef(null);
  useEffect(function () {
    if (props.debug) {
      console.log(
        'Called useEffect hook with params:\ncaptchaRendered: '
          .concat(props.captchaRendered, '\ncontainer: ')
          .concat(container.current)
      );
    }
    if (!props.captchaRendered && container.current) {
      if (props.debug) {
        console.log('Creating new widget instance');
      }
      props.captchaWidget.current = new WidgetInstance(container.current, {
        puzzleEndpoint: FC_PUZZLE_EP(props.endpoint),
        startMode: props.startMode,
        doneCallback: props.solvedHandler,
        errorCallback: props.errorHandler,
        sitekey: props.siteKey,
        language: props.language,
      });
      if (props.debug) {
        console.log('Set captcha to rendered: true');
      }
      props.setCaptchaRendered(true);
    }
    return function () {
      if (props.captchaWidget.current !== null && props.captchaRendered) {
        if (props.debug) {
          console.log('Destroying current widget instance');
        }
        props.captchaWidget.current.destroy();
        props.setCaptchaRendered(false);
        props.resetHandler();
      }
    };
  }, []);
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    !props.showAttribution &&
      /*#__PURE__*/ React.createElement(
        'style',
        null,
        '.frc-banner { display: none }'
      ),
    ((ref = props.customWidgetStyle) === null || ref === void 0
      ? void 0
      : ref.icon) &&
      /*#__PURE__*/ React.createElement(
        'style',
        null,
        '#use-friendly-captcha-container .frc-icon {'.concat(
          cssToString(props.customWidgetStyle.icon),
          '}'
        )
      ),
    ((ref1 = props.customWidgetStyle) === null || ref1 === void 0
      ? void 0
      : ref1.button) &&
      /*#__PURE__*/ React.createElement(
        'style',
        null,
        '#use-friendly-captcha-container .frc-button {'.concat(
          cssToString(props.customWidgetStyle.button),
          '}'
        )
      ),
    ((ref2 = props.customWidgetStyle) === null || ref2 === void 0
      ? void 0
      : ref2.text) &&
      /*#__PURE__*/ React.createElement(
        'style',
        null,
        '#use-friendly-captcha-container .frc-text {'.concat(
          cssToString(props.customWidgetStyle.text),
          '}'
        )
      ),
    /*#__PURE__*/ React.createElement('div', {
      'ref': container,
      'id': 'use-friendly-captcha-container',
      'className': props.className,
      'data-sitekey': props.siteKey,
    })
  );
};
var CaptchaWidget = /*#__PURE__*/ React.memo(FriendlyCaptcha);
/**
 * React hook that manages the widget and the states for the friendly captcha
 * @param siteKey defined sitekey for the particular domain
 * @param language sets the widget language (default: de)
 * @param startMode sets the widget startmode (default: auto)
 * @param endpoint captcha url that is used to create the puzzle (default: global endpoint)
 * @param showAttribution boolean to determine if the friendly captcha banner should be shown.
 * @param debug enable debug mode, which logs the hooks process, which helps with debugging.
 * @returns { CaptchaWidget, captchaStatus } CaptchaWidget the JSX widget to add in the DOM tree and captchaStatus the state of the current captcha, containing if it's solved successfull, not successfull or hasn't been checked yet
 */ function useCaptchaHook(param) {
  var siteKey = param.siteKey,
    _endpoint = param.endpoint,
    endpoint = _endpoint === void 0 ? 'GLOBAL1' : _endpoint,
    _language = param.language,
    language = _language === void 0 ? 'de' : _language,
    _startMode = param.startMode,
    startMode = _startMode === void 0 ? 'auto' : _startMode,
    _showAttribution = param.showAttribution,
    showAttribution = _showAttribution === void 0 ? true : _showAttribution,
    _debug = param.debug,
    debug = _debug === void 0 ? false : _debug;
  var ref = _slicedToArray(
      useState({
        solution: null,
        error: null,
      }),
      2
    ),
    captchaStatus = ref[0],
    setCaptchaStatus = ref[1];
  var ref1 = _slicedToArray(useState(false), 2),
    captchaRendered = ref1[0],
    setCaptchaRendered = ref1[1];
  var captchaWidget = useRef(null);
  var solvedHandler = function (solution) {
    if (debug) {
      console.log('Set captcha to solved, with solution: '.concat(solution));
    }
    setCaptchaStatus({
      solution: solution,
      error: null,
    });
  };
  var errorHandler = function (error) {
    console.log(error.description);
    setCaptchaStatus({
      solution: null,
      error: error,
    });
  };
  var resetHandler = function () {
    if (debug) {
      console.log('Reseting captcha status');
    }
    setCaptchaStatus({
      solution: null,
      error: null,
    });
  };
  var resetWidget = function () {
    if (debug) {
      console.log('Captcha is getting resetted.');
    }
    if (captchaWidget.current !== null) {
      var ref;
      (ref = captchaWidget.current) === null || ref === void 0
        ? void 0
        : ref.reset();
      setCaptchaStatus({
        solution: null,
        error: null,
      });
    } else {
      if (debug) {
        console.log(
          "Couldn't reset widget, as widget wasn't instantiated yet."
        );
      }
    }
  };
  return {
    CaptchaWidget: function (widgetProps, customWidgetStyle) {
      return /*#__PURE__*/ React.createElement(
        CaptchaWidget,
        _extends(
          {
            siteKey: siteKey,
            endpoint: endpoint,
            language: language,
            startMode: startMode,
            showAttribution: showAttribution,
            solvedHandler: solvedHandler,
            errorHandler: errorHandler,
            resetHandler: resetHandler,
            captchaRendered: captchaRendered,
            captchaWidget: captchaWidget,
            setCaptchaRendered: setCaptchaRendered,
            customWidgetStyle: customWidgetStyle,
            debug: debug,
          },
          widgetProps
        )
      );
    },
    captchaStatus: captchaStatus,
    resetWidget: resetWidget,
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
      }
      _next(undefined);
    });
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var __generator =
  (undefined && undefined.__generator) ||
  function (thisArg, body) {
    var f,
      y,
      t,
      g,
      _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2),
      }),
      typeof Symbol === 'function' &&
        (g[Symbol.iterator] = function () {
          return this;
        }),
      g
    );
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError('Generator is already executing.');
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t =
                op[0] & 2
                  ? y['return']
                  : op[0]
                  ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                  : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return {
                value: op[1],
                done: false,
              };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (
                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                (op[0] === 6 || op[0] === 2)
              ) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true,
      };
    }
  };
function FC_VERIFICATION_EP(endpoint) {
  switch (endpoint) {
    case 'GLOBAL1':
      return 'https://api.friendlycaptcha.com/api/v1/siteverify';
    case 'EU1':
      return 'https://eu-api.friendlycaptcha.eu/api/v1/siteverify';
  }
}
function FCVerification(_param) {
  return _FCVerification.apply(this, arguments);
}
function _FCVerification() {
  _FCVerification =
    /* Example function for an axios fetcher function (http POST)
async function httpPostFetcherExample(
  endpoint: string,
  requestBody: { solution: string; secret: string; siteKey: string },
  headers: { 'Content-Type': 'application/json'; 'Accept': 'application/json' }
): Promise<CaptchaResponse | null> {
  return new Promise<CaptchaResponse | null>(async (res) => {
    try {
      const { data } = await axios.post<CaptchaResponse>(
        endpoint,
        { ...requestBody },
        {
          headers: { ...headers },
        }
      );

      res(data);
    } catch (err) {
      res(null);
    }
  });
}
 */ /**
     * Backend verification function that uses the FC verification API to check if the form from the submitted puzzle is valid
     * @param endpoint the endpoint to send the solved puzzle to for verification (default: global endpoint)
     * @param props including all necessary data for the verification. Sitekey is optional, if you want to make sure that the puzzle is generated from your expected site
     * @returns boolean depending on if the request yields a success or an error
     */ _asyncToGenerator(function (_param) {
      var _endpoint, endpoint, props;
      return __generator(this, function (_state) {
        (_endpoint = _param.endpoint),
          (endpoint = _endpoint === void 0 ? 'GLOBAL1' : _endpoint),
          (props = _objectWithoutProperties(_param, ['endpoint']));
        return [
          2,
          new Promise(
            (function () {
              var _ref = _asyncToGenerator(function (res) {
                var data, _tmp, _tmp1, error;
                return __generator(this, function (_state) {
                  switch (_state.label) {
                    case 0:
                      _state.trys.push([0, 2, , 3]);
                      _tmp = {};
                      _tmp1 = {};
                      return [
                        4,
                        props.httpPostFetcher(
                          FC_VERIFICATION_EP(endpoint),
                          ((_tmp.solution = props.solution),
                          (_tmp.secret = props.secret),
                          (_tmp.siteKey = props.sitekey),
                          _tmp),
                          ((_tmp1['Content-Type'] = 'application/json'),
                          (_tmp1['Accept'] = 'application/json'),
                          _tmp1)
                        ),
                      ];
                    case 1:
                      data = _state.sent();
                      if (data === null) {
                        throw new Error(
                          'Network error while trying to verify captcha solution'
                        );
                      }
                      if (!data.success) {
                        // recommended best practice, still return true if status doesn't match 200
                        console.log(data.errors.toString());
                        res(data.errors.status != '200');
                      } else {
                        res(true);
                      }
                      return [3, 3];
                    case 2:
                      error = _state.sent();
                      console.error(error);
                      res(false);
                      return [3, 3];
                    case 3:
                      return [2];
                  }
                });
              });
              return function (res) {
                return _ref.apply(this, arguments);
              };
            })()
          ),
        ];
      });
    });
  return _FCVerification.apply(this, arguments);
}

export { FCVerification, useCaptchaHook };
